import React from 'react';
import { makeStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/AddCircleOutlineRounded';
import ImageDropzone from '../../../Dropzone/ImageDropzone';

const useStyles = makeStyles({
  createCardRoot: {
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    position: 'relative'
  },
  createBoxRoot: {
    height: '100%'
  }
});

const CreateStepPlaceholder = ({
  thumbnailHeight,
  thumbnailWidth,
  onAddStep
}) => {
  const classes = useStyles();

  function handleUploadPicture(image) {
    onAddStep({ image });
  }

  return (
    <Card classes={{ root: classes.createCardRoot }} onClick={onAddStep}>
      <ImageDropzone
        thumbnailHeight={thumbnailHeight}
        thumbnailWidth={thumbnailWidth}
        onUploadImage={handleUploadPicture}
        noClick
        multiple
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          className={classes.createBoxRoot}
        >
          <AddIcon fontSize="large" color="secondary" />
          <Typography variant="subtitle2">Add Step</Typography>
        </Box>
      </ImageDropzone>
    </Card>
  );
};

export default CreateStepPlaceholder;
